// Spiegazioni delle categorie di tesseramento (fonte: Tesseramento 2026 — Settore Motori MSP Italia)
export const MSP_PDF = "/docs/tesseramento-2026-msp-settore-motori.pdf";

export const TESSERE_SPIEGAZIONI = [
  {
    id: "team",
    titolo: "Con il Legend Team partecipano tutti",
    testo:
      "Come scuderia affiliata possiamo far correre chiunque sotto i nostri colori: piloti, navigatori, tecnici, semplici sostenitori. " +
      "Scegli la tessera Legend più adatta e, se vuoi gareggiare, aggiungi la licenza conduttore MSP della tua disciplina: " +
      "il team ti accompagna nelle pratiche, in assistenza e nel paddock.",
  },
  {
    id: "societa-vs-attivita",
    titolo: "Tessera Società o Tessera Attività / Licenza Conduttore?",
    testo:
      "La Tessera Società (Base o Tecnico) serve per aderire a MSP Italia Settore Motori senza guidare in gara: sostenitori, accompagnatori, " +
      "ruoli tecnici e sportivi. La Tessera Attività, detta anche Licenza Conduttore, è invece quella che abilita a guidare o correre nella disciplina scelta. " +
      "Entrambe sono un unico documento elettronico in PDF: personale, incedibile e numerato.",
  },
  {
    id: "base-tecnico",
    titolo: "Base (10 €) e Tecnico (20 €)",
    testo:
      "Base è la tessera di adesione o sostenitore, senza alcuna visita medica. Tecnico è pensata per chi ricopre ruoli tecnico-sportivi " +
      "nel team (meccanici, assistenza, direzione, ufficiali): nessuna visita medica richiesta.",
  },
  {
    id: "promo-vs-sportiva",
    titolo: "Promo (35 €) o Sportiva (80–100 €)?",
    testo:
      "Le licenze Promo sono l'ingresso nel motorsport: attività non agonistica, basta la visita medica generica (certificato sportivo non agonistico). " +
      "Le licenze Sportiva sono per l'attività agonistica vera e propria e richiedono la visita medico-sportiva agonistica: tipo A1 per l'automobilismo " +
      "e per la Velocità moto, tipo B1 per le altre discipline motociclistiche.",
  },
  {
    id: "territoriale-nazionale",
    titolo: "Sportiva Territoriale (80 €) o Nazionale (100 €)",
    testo:
      "Nell'automobilismo Abilità la licenza Territoriale vale per le gare della propria area, la Nazionale per tutto il calendario italiano. " +
      "Se parti con la Territoriale e vuoi correre ovunque puoi estenderla a Nazionale con la quota di 25 €.",
  },
  {
    id: "discipline",
    titolo: "Le discipline",
    testo:
      "Automobilismo: Abilità (slalom, rally e prove su strada chiusa), Karting, Fuoristrada. " +
      "Motociclismo: Enduro (EN), Motocross (MX), Supermoto / Flat Track (SM/FT), Quad (QD), Velocità (VT).",
  },
  {
    id: "quota",
    titolo: "Cosa comprende la quota",
    testo:
      "Ogni quota include l'affiliazione, l'adesione all'attività del Settore Motori e le coperture assicurative abbinate alla card, " +
      "secondo la Polizza Tesseramento MSP Italia. Sono disponibili coperture aggiuntive per le attività del Settore Motori tramite l'ASD SportItalia.",
  },
  {
    id: "come-fare",
    titolo: "Come si procede",
    testo:
      "Compila il modulo di tesseramento con i tuoi dati e il documento d'identità, scegli la tessera o la licenza, paga online in sicurezza. " +
      "La registrazione ufficiale avviene entro 5 giorni con codice identificativo; per le licenze Sportiva ricordati il certificato medico agonistico.",
  },
];
